export default function(data) {
  const journeys = {}

  if (data && Array.isArray(data)) {
    journeys.userAdded = data.filter(item => item.isAddedByUser) || []
    journeys.def = data.filter(item => !item.isAddedByUser) || []
    journeys.brandNew = []
  }

  return journeys
}
